/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaskReferenceRequirementEnum = {
    Hidden: 'HIDDEN',
    Optional: 'OPTIONAL',
    Mandatory: 'MANDATORY'
} as const;
export type TaskReferenceRequirementEnum = typeof TaskReferenceRequirementEnum[keyof typeof TaskReferenceRequirementEnum];

